module.exports = __webpack_public_path__ + "img/inside-back.cdc599d5.svg";